import { ErrorObject } from './api-request';

export const isApiError = (x: unknown): x is ErrorObject => {
  if (x && typeof x === 'object' && 'message' in x) {
    return true;
  }
  return false;
};
